import { productVariants } from './variants.i18n';

export const en = {
  productVariants,
};
